import React, {useContext, useEffect, useState} from "react";
import Lottie from "lottie-react-web";
import Icon from "@material-ui/core/Icon";
import { Link, useLocation } from "react-router-dom";
// import Link from 'next/link';
// import {useRouter} from 'next/router';

import homeIcon from "../../../assets/images/icons/home.svg";
import liveIcon from "../../../assets/images/icons/live.svg";
import doubtIcon from "../../../assets/images/icons/doubt.svg";
import earningIcon from "../../../assets/images/icons/rupee_symbol.svg";
import blazeIcon from "../../../assets/images/icons/flash.svg";
import glowIndicator from "../../../assets/lottie/glow_indicator.json";
import homeIconSelected from "../../../assets/images/icons/home_selected.svg";
import homeIconSelected2 from "../../../assets/images/icons/home_selected2.svg";
import liveIconSelected from "../../../assets/images/icons/live_selected.svg";
import liveIconSelected2 from "../../../assets/images/icons/live_selected2.svg";
import doubtIconSelected from "../../../assets/images/icons/doubt_selected.svg";
import doubtIconSelected2 from "../../../assets/images/icons/doubt_selected2.svg";
import earningsIconSelected from "../../../assets/images/icons/rupee_symbol_selected.svg";
import earningsIconSelected2 from "../../../assets/images/icons/rupee_symbol_selected2.svg";
import {
  UserContext,
  ThemeContext,
  IntroContext,
} from "../../../context";

export default function MobileMenuItems({
                                          blazeNewMsg,
                                        }) {
  const [isDark] = useContext(ThemeContext).theme;
  //
  const [, setAnchor] = useContext(IntroContext).anchor;
  //
  const [hasSessions] = useContext(UserContext).hasSessions;
  const [selectedMenuItem, setMenuItem] = useState(null);
  //
  // const [bounce, setBounce] = useContext(UserContext).bounceBlazeIcon;

  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname;

    if (currentPath.includes("/blaze")) {
      setMenuItem("blaze");
    } else if (currentPath.includes("/sessions")) {
      setMenuItem("sessions");
    } else if (currentPath.includes("/outreach")) {
      setMenuItem("outreach");
    } else if (currentPath === "/earnings") {
      setMenuItem("earnings");
    } else if (currentPath === "/") {
      setMenuItem("homepage");
    }
  }, [location]);

  const getClassName = (name) =>
    selectedMenuItem === name
      ? isDark
        ? `navbar-item active ${name} navbar-item-dark`
        : `navbar-item ${name} active`
      : isDark
        ? "navbar-item navbar-item-dark"
        : "navbar-item";

  const handleClick = (event) => {
    setAnchor(event.currentTarget);
  };

  return (
    <div className="header__middle__sm">
      <div className="left__menu">
        <Link
          to="/"
          onClick={(e) => {
            setMenuItem("homepage");
            handleClick(e);
            navigator && navigator.vibrate && navigator.vibrate(5);
          }}
          className={getClassName("homepage")}
          style={{ textDecoration: "inherit" }}
          id="homeIntro"
        >
          <div className="nav__box__wrapper">
            <Icon className="nav__icon">
              <img height={100} width={100}
                     className="nav__icon__img"
                     src={
                       selectedMenuItem === "homepage"
                         ? isDark
                           ? homeIconSelected2
                           : homeIconSelected
                         : homeIcon
                     }
                     alt="Home Icon"
              />
            </Icon>
            <p
              style={{
                color:
                  selectedMenuItem === "homepage" &&
                  (isDark ? "#39d9f9" : "#4C72FA"),
              }}
            >
              Home
            </p>
          </div>
        </Link>
        <Link
          to="/sessions"
          onClick={(e) => {
            setMenuItem("homepage");
            handleClick(e);
            navigator && navigator.vibrate && navigator.vibrate(5);
          }}
          className={getClassName("sessions")}
          style={{ textDecoration: "inherit" }}
          id="homeIntro"
        >
          <div className="nav__box__wrapper">
            <Icon className="nav__icon">
              <img height={100} width={100}
                   className="nav__icon__img"
                   src={
                     selectedMenuItem === "sessions"
                       ? isDark
                         ? liveIconSelected2
                         : liveIconSelected
                       : liveIcon
                   }
                   alt="Home Icon"
              />
            </Icon>
            <p
              style={{
                color:
                  selectedMenuItem === "sessions" &&
                  (isDark ? "#ff512f" : "#dd2476"),
              }}
            >
              My Sessions
            </p>
          </div>
        </Link>
      </div>
      <div className="middle__menu">
        <svg
          width={115}
          height={76}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#a)">
            <path
              d="M104.5 12.845V19L57 66 10 19v-5.065c0-1.723 2.033-2.64 3.324-1.5l43.351 38.288a4 4 0 0 0 5.483-.177l38.924-39.112c1.259-1.264 3.418-.373 3.418 1.41Z"
              fill="#232323"
              fillOpacity={0.07}
            />
          </g>
          <path
            d="M109 16.603V71H6V16.603c0-1.781 2.154-2.674 3.414-1.414L50.43 56.204c3.905 3.905 10.237 3.905 14.142 0l41.015-41.015c1.26-1.26 3.414-.367 3.414 1.414Z"
            fill="var(--color-navbar)"
          />
          <defs>
            <filter
              id="a"
              x={0}
              y={0.841}
              width={114.5}
              height={75.159}
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity={0} result="BackgroundImageFix" />
              <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
              <feGaussianBlur
                stdDeviation={5}
                result="effect1_foregroundBlur_126_19"
              />
            </filter>
          </defs>
        </svg>
        {/*<div className="left__fall" />*/}
        <Link
          to="/blaze"
          onClick={(e) => {
            setMenuItem("blaze");
            handleClick(e);
            navigator && navigator.vibrate && navigator.vibrate(5);
            // setBounce(true);
            // setTimeout(() => setBounce(false), 150);
          }}
          className={
            isDark
              ? "navbar-item navbar-item-dark diamond"
              : "navbar-item diamond"
          }
          style={{
            textDecoration: "inherit",
            // animation:
            //   location.pathname.includes("/blaze") &&
            //   bounce &&
            //   "bounce 0.15s ease both",
          }}
          id="blazeIntro"
        >
          <div className="nav__box__wrapper diamond__blaze">
            <Icon className="nav__icon">
              {blazeNewMsg && (
                <div className="has__sessions">
                  <div class="red__wrapper">
                    <div className="dot__red count blaze" />
                  </div>
                </div>
              )}
              <img height={100} width={100}
                     className="nav__icon__img"
                     src={blazeIcon}
                     alt="Blaze Icon"
              />
            </Icon>
          </div>
        </Link>
        {/*<div className="blaze__waterfall" />*/}
        {/*<div className="blaze__waterfall border" />*/}
        {/*<div className="blaze__bg__blur" />*/}
        {/*<div className="right__fall" />*/}
      </div>

      <div className="right__menu">
        <Link
          to="/outreach"
          style={{ textDecoration: "inherit" }}
          className={getClassName("outreach")}
          onClick={(e) => {
            setMenuItem("outreach");
            handleClick(e);
            navigator && navigator.vibrate && navigator.vibrate(5);
          }}
          id="classesIntro"
        >
          <div className="nav__box__wrapper">
            <Icon className="nav__icon">
              <svg
                style={{flexShrink: 0, fill: selectedMenuItem === 'outreach' ? (isDark ? '#9ce85e' : 'rgb(31, 191, 255)') : '#000'}}
                xmlns="http://www.w3.org/2000/svg"
                width={23}
                className="nav__icon__img"
                height={23}
                viewBox="0 0 511.92 511.92"
                // fill={'#fff'}
              >
                <path
                  d="M94.207 270.961H0c2.964 51.719 21.223 100.544 52.607 141.224 17.651-9.969 37.467-18.517 58.874-25.488-10.186-35.589-16.108-74.886-17.274-115.736zM94.207 240.961c1.166-40.851 7.088-80.148 17.275-115.739-21.408-6.97-41.223-15.518-58.874-25.488C21.223 140.415 2.964 189.241 0 240.961zM165.225 71.19c-5.696 10.518-10.839 21.798-15.411 33.713 28.49 6.809 59.317 10.875 91.148 11.848V1.274c-28.023 6.409-54.482 30.665-75.737 69.916zM270.961 1.274V116.75c31.829-.973 62.656-5.04 91.146-11.848-4.573-11.914-9.716-23.195-15.411-33.713-21.255-39.249-47.714-63.505-75.735-69.915zM371.611 133.412c-31.512 7.743-65.581 12.331-100.65 13.35v94.198h116.738c-1.148-38.116-6.656-74.635-16.088-107.548zM120.837 415.148c-17.338 5.647-33.482 12.407-48.072 20.185.631.644 1.25 1.296 1.888 1.934 26.686 26.686 58.224 46.748 92.617 59.399-10.249-11.767-19.783-25.69-28.426-41.65-6.719-12.408-12.727-25.759-18.007-39.868zM391.083 96.772c17.338-5.647 33.482-12.407 48.072-20.184-.631-.644-1.25-1.296-1.888-1.934-26.686-26.686-58.224-46.748-92.617-59.399 10.249 11.767 19.783 25.69 28.426 41.65 6.719 12.407 12.727 25.758 18.007 39.867zM417.714 270.961c-1.166 40.85-7.089 80.147-17.275 115.737 21.408 6.97 41.223 15.518 58.874 25.488 31.385-40.68 49.643-89.505 52.607-141.224h-94.206zM391.083 415.148c-5.28 14.109-11.288 27.459-18.008 39.867-8.642 15.96-18.177 29.883-28.426 41.65 34.393-12.651 65.931-32.713 92.617-59.399.638-.638 1.257-1.29 1.887-1.934-14.589-7.776-30.732-14.537-48.07-20.184zM120.837 96.772c5.28-14.109 11.288-27.459 18.008-39.867 8.642-15.96 18.177-29.883 28.426-41.65-34.393 12.651-65.931 32.713-92.617 59.399-.638.638-1.257 1.29-1.887 1.934 14.589 7.777 30.732 14.537 48.07 20.184zM400.438 125.222c10.187 35.591 16.109 74.888 17.275 115.739h94.207c-2.964-51.72-21.223-100.546-52.607-141.226-17.652 9.969-37.467 18.517-58.875 25.487zM240.961 240.961v-94.198c-35.069-1.019-69.139-5.608-100.652-13.35-9.432 32.912-14.941 69.431-16.088 107.549h116.74zM270.961 270.961v94.196c35.068 1.02 69.138 5.608 100.65 13.35 9.432-32.912 14.94-69.43 16.088-107.547H270.961zM346.695 440.731c5.696-10.518 10.839-21.798 15.411-33.713-28.49-6.809-59.316-10.875-91.146-11.848v115.476c28.022-6.41 54.481-30.666 75.735-69.915zM240.961 510.646V395.17c-31.83.973-62.657 5.039-91.148 11.848 4.573 11.914 9.716 23.195 15.412 33.713 21.255 39.25 47.714 63.506 75.736 69.915zM240.961 270.961h-116.74c1.148 38.117 6.656 74.635 16.088 107.547 31.512-7.743 65.582-12.331 100.652-13.35z"/>
              </svg>
            </Icon>
            <p
              style={{
                color:
                  selectedMenuItem === "outreach" &&
                  (isDark ? "#9ce85e" : "#1FBFFF"),
              }}
            >
              Outreach
            </p>
          </div>
        </Link>
        <Link
          to="/earnings"
          style={{ textDecoration: "inherit" }}
          className={getClassName("earnings")}
          onClick={(e) => {
            setMenuItem("earnings");
            handleClick(e);
            navigator && navigator.vibrate && navigator.vibrate(5);
          }}
          id="classesIntro"
        >
          <div className="nav__box__wrapper">
            <Icon className="nav__icon" style={{padding: '1.6px'}}>
              {hasSessions && (
                <div className="has__sessions">
                  <div class="red__wrapper">
                    <div className="dot__red" />
                    <div className="red__bg">
                      <Lottie
                        options={{ animationData: glowIndicator, loop: true }}
                        speed={1.5}
                      />
                    </div>
                  </div>
                </div>
              )}
              <img height={100} width={100}
                   className="nav__icon__img"
                   src={
                     selectedMenuItem === "earnings"
                       ? isDark
                         ? earningsIconSelected
                         : earningsIconSelected2
                       : earningIcon
                   }
                   alt="Earnings Icon"
              />
            </Icon>
            <p
              style={{
                color:
                  selectedMenuItem === "earnings" &&
                  (isDark ? "#ad63b1" : "#ad63b1"),
              }}
            >
              Earnings
            </p>
          </div>
        </Link>
      </div>
    </div>
  );
}
